import { render, staticRenderFns } from "./mobile_addressList.vue?vue&type=template&id=136f73d4&scoped=true&"
import script from "./mobile_addressList.vue?vue&type=script&lang=js&"
export * from "./mobile_addressList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136f73d4",
  null
  
)

export default component.exports